import { time } from '../../utils'

export const DISABLED_DATE = +new Date('2068-01-01 23:59:59')

export const VALUE_FORMAT = 'yyyy-MM-dd HH:mm:ss'

export const FORMAT = (val, fmt) => {
  // 类型为datas，val是数组
  if (fmt === 'timestamp' || Array.isArray(val)) {
    return val
  } else {
    return time(val, fmt.replace(/y/g, 'Y').replace(/d/g, 'D'))
  }
}

const FORMATMAP = {
  year: 'yyyy',
  month: 'yyyy-MM',
  date: 'yyyy-MM-dd',
  datetime: 'yyyy-MM-dd HH:mm',
  daterange: 'yyyy-MM-dd',
  datetimerange: 'yyyy-MM-dd HH:mm',
}

export default {
  name: 'kye-date-picker',
  props: {
    type: {
      type: String,
      default: 'date'
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    },
    disabledMaxdate: {
      type: Boolean,
      default: false
    },
    disableDelete: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.resetEnter()
    if (!this.disabledMaxdate && !(this.type === 'daterange' || this.type === 'datetimerange')) {
      this.resetHandleChange()
    }
  },
  render (h) {
    const data = this.$vnode.data
    const on = data.on || {}
    data.on = { ...on, ...this.$listeners }
    const attrs = this.$attrs
    let valueFormat = attrs['value-format'] || attrs.valueFormat || VALUE_FORMAT
    let format = attrs.format ? attrs.format.replace(':ss', '') : FORMATMAP[this.type]
    // 自定义 format2 > format
    if (attrs.format2) {
      format = attrs.format2
    }
    if (format === 'yyyy-MM') {
      valueFormat = format
    }

    const props = data.props || {}
    let value = props.value || attrs.value || ''
    data.props = { ...props, format, valueFormat, value, type: this.type }
    // 2022-09-01 修复由于date-range中取值错误以及此处的 pickerOptions获取是通过props来获取，但是未放入 data.attrs 中，导致 date-range.vue中获取不到使用者传递的 pickerOptions问题
    if (this.pickerOptions && Object.keys(this.pickerOptions).length && data.attrs && !data.attrs.pickerOptions) {
      data.attrs.pickerOptions = this.pickerOptions
    }
    if (this.type === 'daterange' || this.type === 'datetimerange') {
      return h('kye-date-range', data, this.$slots.default)
    }

    let newVal = null
    if (value && (typeof value !== 'string' || (typeof value === 'string' && value.length !== valueFormat.length))) {
      newVal = FORMAT(value, valueFormat)
    }
    data.props.pickerOptions = this.pickerOptions
    if (!this.pickerOptions.disabledDate) {
      data.props.pickerOptions.disabledDate = time => time.getTime() > DISABLED_DATE
    }
    let onInput = data.on.input
    if (onInput) {
      let operation = attrs.operation
      data.on.input = (val) => {
        if (typeof val !== 'string') {
          val = FORMAT(val, valueFormat)
        } else if (val && operation && valueFormat === VALUE_FORMAT) {
          // 通用查询 条件关系
          if (this.type === 'date') {
            switch (operation) {
              case 'greaterthan': // '>'
              case 'lessthanorequal': // '<='
                val = val.slice(0, 11) + '23:59:59'
                break
              case 'lessthan': // '<'
              case 'greaterthanorequal': // '>='
                val = val.slice(0, 11) + '00:00:00'
                break
            }
          } else if (this.type === 'datetime' && operation === 'between' && format !== VALUE_FORMAT) {
            let end = val.includes('23:59') ? ':59' : ':00'
            val = val.replace(/:\d{2}$/, end)
          }
        }
        onInput(val)
      }
    }

    if (newVal) {
      if (data.model) {
        data.model = { ...data.model, value: newVal }
      }
      data.props = { ...data.props, value: newVal }
      if (data.on.input) {
        data.on.input(newVal)
      }
    }
    return h('el-date-picker', data, this.$slots.default)
  },
  methods: {
    resetEnter () {
      let c = this.$children[0]
      if (c) {
        c.handleKeydown = (e) => {
          const keyCode = e.keyCode

          // Delete
          if ((keyCode === 8 || keyCode === 46) && this.disableDelete) {
            e.stopPropagation()
            e.preventDefault()
            return
          }

          // ESC
          if (keyCode === 27) {
            c.pickerVisible = false
            e.stopPropagation()
            return
          }

          // Tab
          if (keyCode === 9) {
            if (!c.ranged) {
              c.handleChange()
              c.pickerVisible = c.picker.visible = false
              c.blur()
              e.stopPropagation()
            } else {
              // user may change focus between two input
              setTimeout(() => {
                if (c.refInput.indexOf(document.activeElement) === -1) {
                  c.pickerVisible = false
                  c.blur()
                  e.stopPropagation()
                }
              }, 0)
            }
            return
          }

          // Enter
          if (keyCode === 13) {
            if (c.userInput === '' || c.isValidValue(c.parseString(c.displayValue))) {
              c.handleChange()
              c.pickerVisible = c.picker.visible = false
              // c.blur()
            }
            e.stopPropagation()
            return
          }

          // if user is typing, do not let picker handle key input
          if (c.userInput) {
            e.stopPropagation()
            return
          }

          // delegate other keys to panel
          if (c.picker && c.picker.handleKeydown) {
            c.picker.handleKeydown(e)
          }
        }
      }
    },
    focus () {
      this.$children[0] && this.$children[0].focus()
    },
    resetHandleChange() {
      if (this.$children.length === 1) {
        let c = this.$children[0]
        c.handleChange = () => {
          if (c.userInput) {
            let value = c.parseString(c.displayValue)
            if (value) {
              if (+new Date(value) > DISABLED_DATE) {
                c.userInput = null
                value = c.parseString(c.displayValue)
              }
              c.picker.value = value
              if (c.isValidValue(value)) {
                c.emitInput(value)
                c.userInput = null
              }
            }
          }
          if (c.userInput === '') {
            c.emitInput(null)
            c.emitChange(null)
            c.userInput = null
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker/index.js